import Col from '../../../components/Col';
import { Table } from '../../../components';
import { formatName } from '../../../common';

import React, { Fragment } from 'react';
import { get, map } from 'lodash';

const colSpan = 3;

// <Col /* B.W. */ width="5em" />
const AthleteCellsColGroup = () => (
  <colgroup>
    <Col /* # */ width="2.5em" />
    <Col /* Name */ />
    <Col /* Team */ width="6em" />
  </colgroup>
);

const AthleteCellsHeader1 = () => (
  <Table.HeaderCell colSpan={colSpan}>Athlete</Table.HeaderCell>
);

const AthleteCellsHeader2 = () => (
  <Fragment>
    <Table.HeaderCell>#</Table.HeaderCell>
    <Table.HeaderCell>Name</Table.HeaderCell>
    {/*<Table.HeaderCell>B.W.</Table.HeaderCell>*/}
    <Table.HeaderCell>Team</Table.HeaderCell>
  </Fragment>
);

console.error('FIXME: Only make name selectable if manual mode');
const AthleteCells = ({ athlete, callingOrder }) => {
  const highlights = {
    [-1]: 'disabled',
    0: 'positive',
    1: 'warning',
  };
  const highlight = highlights[callingOrder];
  const cellProps = {
    ...(highlight ? { [highlight]: true } : {}),
  };
  return (
    <Fragment>
      <Table.Cell {...cellProps}>{athlete.startNumber}</Table.Cell>
      <Table.Cell selectable {...cellProps}>
        <a
        //inverted={inverted}
        //basic={basic}
        //color={color}
        >
          {formatName(athlete.entry)}
        </a>
      </Table.Cell>
      {/*<Table.Cell {...cellProps}>999.99</Table.Cell>*/}
      <Table.Cell {...cellProps}>
        {map(get(athlete.entry, 'teams'), 'abbreviation').join(', ')}
      </Table.Cell>
    </Fragment>
  );
};

AthleteCells.ColGroup = AthleteCellsColGroup;
AthleteCells.Header1 = AthleteCellsHeader1;
AthleteCells.Header2 = AthleteCellsHeader2;
AthleteCells.colSpan = colSpan;

export default AthleteCells;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/AthleteCells.js